import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import { Loader } from '../../components/_atoms/_Loader';
import { Center } from '../../components/_atoms/Center';
import { NextPageWithLayout } from '../../components/layouts';
import { getBaseUrl } from '../../utils/client';
import { detectAndBestEffortSetLanguage } from '../../utils/localisationUtils';

/**
 * Due to Plausible. This page exists to track conversion rate when signing up.
 */
const SignupSuccess: NextPageWithLayout = () => {
  const router = useRouter();
  const ref = useRef<NodeJS.Timeout | undefined>(undefined);
  useEffect(() => {
    if (router) {
      const callbackURI = router.query.callbackURI as string | undefined;
      if (callbackURI) {
        router.replace(callbackURI);
      } else {
        router.replace('/home');
      }
      return;
    }
    // A timeout that makes sure the user is not stuck on this site
    if (!ref.current) {
      ref.current = setTimeout(() => {
        window.location.replace(`${getBaseUrl()}/home`);
      }, 10000);
    }
    return () => {
      if (ref.current) clearTimeout(ref.current);
    };
  }, [router]);
  return (
    <Center style={{ width: '100%', height: '100%' }}>
      <Loader />
    </Center>
  );
};
export const getServerSideProps: GetServerSideProps = async context => {
  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=300, stale-while-revalidate=3600',
  );
  return {
    props: {
      ...(await detectAndBestEffortSetLanguage(context)),
    },
  };
};
export default SignupSuccess;
